<template>
	<!-- 用户切换身份 101171570 -->
	<div id="switchRole">
		<ul class="unitArea">
			<!-- 企业 -->
			<li v-if="myInclude(roleIds,'SupervisionUnit')" class="box" :style="getStyle">
				<a href="javascript:void(0)" class="unitName" @click="getUnitType('SupervisionUnit')" :class="{active:roleId=='SupervisionUnit'}">监理单位</a>
			</li>
			<li v-if="myInclude(roleIds,'BuildUnit')" class="box" :style="getStyle">
				<a href="javascript:void(0)" class="unitName" @click="getUnitType('BuildUnit')" :class="{active:roleId=='BuildUnit'}">施工单位</a>
			</li>
			<li v-if="myInclude(roleIds,'unit')" class="box" :style="getStyle">
				<a href="javascript:void(0)" class="unitName" @click="getUnitType('unit')" :class="{active:roleId=='unit'}">建设单位</a>
			</li>

			<!-- 人员 -->
			<li v-if="myInclude(roleIds,'SE')" class="box" :style="getStyle">
				<a href="javascript:void(0)" class="unitName" @click="getUnitType('SE')" :class="{active:roleId=='SE'}">总监理工程师</a>
			</li>
			<li v-if="myInclude(roleIds,'pm')" class="box" :style="getStyle">
				<a href="javascript:void(0)" class="unitName" @click="getUnitType('pm')" :class="{active:roleId=='pm'}">项目经理</a>
			</li>
			<li v-if="myInclude(roleIds,'UnitPerson')" class="box" :style="getStyle">
				<a href="javascript:void(0)" class="unitName" @click="getUnitType('UnitPerson')" :class="{active:roleId=='UnitPerson'}">建设单位负责人</a>
			</li>
		</ul>
		<el-select v-model="unitId" placeholder="请选择企业" class="unitSelect" v-loading="loading">
			<el-option v-for="item in options" :key="item.unitId" :label="item.unitName" :value="item.unitId">
			</el-option>
		</el-select>
		<div class="unit-btn-group">
			<center>
				<el-button @click="enterSys" :disabled="unitId==null">切换身份，进入系统</el-button>
				<el-button @click="logout">退出系统</el-button>
			</center>
		</div>
	</div>
</template>

<script>
// SupervisionUnit	监理单位
// BuildUnit	施工单位
// unit	建设单位
import { API_Common } from "@/api/api.js"
export default {
	mounted() {
		this.roleIds = JSON.parse(localStorage.userinfo).roleIds.split(",");
	},
	data() {
		return {
			roleIds: [],
			roleId: null,
			unitId: null,
			options: [],
			loading: false,
		}
	},
	methods: {
		getUnitType(val) {
			let json = JSON.parse(localStorage.userinfo);
			json.roleId = val;
			localStorage.userinfo = JSON.stringify(json)
			this.roleId = val;
			this.loading = true;
			API_Common.Auth.changeUserRole().then(res => {
				if (res.length == 0) {
					this.$notify({
						message: "没有可选的企业，请重新选择角色。",
						offset: document.body.clientHeight - 200,
						type:"info",
						duration: 2000,//设置为0则不自动关闭
					});
					this.options = [];
					this.unitId = null;
					this.loading = false;
					return;
				}
				this.options = res;
				this.unitId = res[0].unitId;
				this.loading = false;
			})
		},
		enterSys() {
			let info = JSON.parse(localStorage.userinfo);
			info.unitId = this.unitId;
			info.roleId = this.roleId;
			localStorage.userinfo = JSON.stringify(info)
			this.$router.replace('/index')
		},
		logout() {
			this.$router.replace('/logout')
		},
		myInclude(list, value) {
			let isInclude = false;
			for (var i = 0; i < list.length; i++) {
				if (list[i] == value) {
					isInclude = true;
					break;
				}
			}
			return isInclude;
		}
	},
	computed: {
		getStyle() {
			if (this.roleIds.length == 3) {
				return { width: '31%', margin: '0 1%' };
			} else {
				return { width: '45%', margin: '0 2%' };
			}
		},
	}
}
</script>

<style>
#switchRole {
	width: 100%;
	height: 100%;
}

#switchRole>.unitArea {
	width: 50%;
	margin: auto;
	left: 0;
	right: 0;
	overflow: hidden;
	position: absolute;
	top: 15%;
	height: 20%;
}

#switchRole>.unitArea>.box {
	float: left;
	width: 31%;
	margin: 0 1%;
	height: 100%;
	display: table;
	background-color: #4e9ddf;
	border-radius: 10px;
	cursor: pointer;
	transition: all 0.4s;
}

#switchRole>.unitArea>.box:hover {
	background-color: #20a0ff;
	transform: scale(1.1);
}

#switchRole>.unitArea>.box .unitName {
	text-align: center;
	color: white;
	font-size: 20px;
	display: table-cell;
	vertical-align: middle;
	border-radius: 10px;
}

#switchRole>.unitArea>.box .unitName.active {
	background-color: #20a0ff;
	text-decoration: none;
	vertical-align: middle;
}

#switchRole>.unitSelect {
	width: 50%;
	position: absolute;
	left: 0;
	right: 0;
	margin: auto;
	top: 35%;
	margin-top: 4%;
}

#switchRole>.unit-btn-group {
	width: 50%;
	position: absolute;
	left: 0;
	right: 0;
	margin: auto;
	bottom: 20%;
	margin-top: 3%;
}
</style>



// WEBPACK FOOTER //
// switchRole.vue?eff80a5c